<template>
    <a-modal
        id="integrate-cb-with-gpt3-modal"
        :title="$t('chatbotv2.integrateChatBotWithChatGPT3')"
        wrapClassName="vertical-center-modal"
        :visible="modalVisible"
        @visibleChange="(isVisible) => $emit('modal-visible2', isVisible)"
        :footer="null"
        @cancel="handleCancel()"
    >
        <a-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
            <a-form-item :label="$t('chatbotv2.integrateOpenAIWithChatbot')">
                <a-radio-group class="row" v-model="gpt3UsageStatus" @change="onChange">
                    <div class="col mb-5">
                        <a-radio class="mb-1 text-bold" :value="'pro'">
                            {{ $t("chatbotv2.gpt3.ownApiKey") }}
                        </a-radio>
                        <a v-if="gpt3UsageStatus === 'pro'" :href="link" target="_blank">
                            <a-alert :message="$t('chatbotv2.gpt3.getApiKey')" type="info" show-icon>
                                <div slot="description">
                                    <p class="overflow-preventer">
                                        {{ $t("chatbotv2.openAISiteRoutingDescStart") }}
                                        <span class="aalert-message">"{{ link }}"</span>
                                        {{ $t("chatbotv2.openAISiteRoutingDescEnd") }}
                                    </p>
                                </div>
                            </a-alert>
                        </a>
                        <a-input
                            autofocus
                            class="mt-2"
                            @change="onChange"
                            v-if="gpt3UsageStatus === 'pro'"
                            :value="apiKey"
                            @input="getInput"
                            :placeholder="$t('chatbotv2.gpt3.typeApiKey')"
                        />
                    </div>
                    <div class="col mb-2">
                        <a-radio class="mb-1 text-bold" :value="'free'">
                            {{ $t("chatbotv2.gpt3.trialApiKey") }}
                        </a-radio>
                        <a-alert
                            v-if="gpt3UsageStatus === 'free'"
                            :message="$t('chatbotv2.gpt3.useOurTrial')"
                            type="info"
                            show-icon
                        >
                            <div slot="description">
                                <p>{{ $t("chatbotv2.gpt3.twentyMessages") }}</p>
                                <p>
                                    {{ $t("chatbotv2.remainingMessageDesc") }}
                                    <span class="aalert-message">{{ trialMessageLimit }}</span>
                                </p>
                            </div>
                        </a-alert>
                    </div>
                </a-radio-group>
            </a-form-item>
        </a-form>
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-row justify-content-start">
                <a-button type="danger" v-if="(!!apiKey && apiKey.length > 0) || trial" @click="revokeDefault()">
                    <span> <a-icon type="api" class="px-1" /></span>{{ $t("chatbotv2.uninstall") }}
                </a-button>
            </div>
            <div class="d-flex flex-row justify-content-end">
                <a-button class="mr-1 ant-btn-primary" @click="handleOk()">
                    {{ $t("chatbotv2.install") }}
                </a-button>
                <a-button class="ml-1" @click="handleCancel()">{{ $t("message.cancel") }}</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "IntegrateChatBotWithChatGPT3",
    props: {
        modalVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isChangedIntegrationState: false,
            gpt3UsageStatus: "",
            tempApiKey: "",
            handleSave: _.debounce((newSettings) => {
                this.updateSettings(newSettings);
            }, 1000).bind(this),
            link: "https://openai.com/api/",
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
        }),
        ...mapGetters({
            trialMessageLimit: "setting/trialMessageLimit",
        }),
        trial: {
            get() {
                const trialValue = _.get(this.settings.gpt3, "trial");
                if (trialValue === true) {
                    this.gpt3UsageStatus = "free";
                }
                return trialValue;
            },
            set(value) {
                this.setValue("gpt3.trial", value);
            },
        },
        apiKey: {
            get() {
                const apiKeyValue = _.get(this.settings.gpt3, "apiKey");
                if (!!apiKeyValue) {
                    this.gpt3UsageStatus = "pro";
                }
                return apiKeyValue;
            },
            set(value) {
                this.setValue("gpt3.apiKey", value);
            },
        },
    },
    methods: {
        ...mapActions({
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
            getSettings: "setting/getSettings",
        }),
        onChange(e) {
            if (this.gpt3UsageStatus === "pro") {
                if (!!this.apiKey) this.isChangedIntegrationState = true;
                else this.isChangedIntegrationState = false;
            } else if (this.gpt3UsageStatus === "free") this.isChangedIntegrationState = true;
        },
        getInput(e) {
            this.tempApiKey = e.target.value;
        },
        handleOk() {
            if (this.gpt3UsageStatus === "free") {
                this.trial = true;
                this.apiKey = null;
            } else if (this.gpt3UsageStatus === "pro") {
                this.trial = false;
                this.apiKey = this.tempApiKey;
                if (!this.apiKey) this.gpt3UsageStatus = "";
            }
            this.handleSave();
            this.closeModal();
        },
        handleCancel() {
            this.closeModal();
            if (!this.trial && !this.apiKey) this.gpt3UsageStatus = "";
            else if (!!this.trial) {
                this.gpt3UsageStatus = "free";
            } else if (!!this.apiKey) {
                this.gpt3UsageStatus = "pro";
            }
        },
        closeModal() {
            this.$emit("modal-visible", false);
            const pathname = `${window.location.pathname}`;
            if (pathname.includes("chatbot")) this.$router.push("/chatbot/integrations");
            this.isChangedIntegrationState = false;
            this.tempApiKey = "";
        },
        revokeDefault() {
            this.trial = false;
            this.apiKey = null;
            this.handleSave();
            this.gpt3UsageStatus = "";
            this.closeModal();
        },
        setValue(key, value) {
            const newSettings = this.setSettingValue({
                setting: key,
                value,
            });

            if (newSettings.then) {
                newSettings.then((x) => this.handleSave(x));
            } else {
                this.handleSave(newSettings);
            }
        },
    },
    mounted() {
        this.getSettings();
    },
};
</script>

<style lang="scss">
.vertical-center-modal {
    text-align: center;
    white-space: nowrap;
}

.vertical-center-modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    width: 0;
}

.vertical-center-modal .ant-modal {
    display: inline-block;
    vertical-align: middle;
    top: 0;
    text-align: left;
}

#integrate-cb-with-gpt3-modal {
    .ant-radio-inner,
    .ant-radio-inner:after {
        border-radius: 2px !important;
    }

    .ant-radio-inner:after {
        border: none !important;
    }

    .ant-radio-inner {
        border-colr: #1890ff;
    }

    .ant-radio-group {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .text-bold {
        font-weight: 700 !important;
    }

    .ant-input:placeholder-shown {
        border: 1px solid #1890ff;
        padding: 17px;
    }

    .aalert-message {
        color: #1890ff;
    }

    .overflow-preventer {
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: initial;
    }
}
</style>
